import { render } from "./TOC.vue?vue&type=template&id=2c677d62&bindings={\"contentElement\":\"props\",\"level\":\"props\",\"titles\":\"data\"}"
import script from "./TOC.vue?vue&type=script&lang=js"
export * from "./TOC.vue?vue&type=script&lang=js"
script.render = render

export default script